module.exports = __webpack_public_path__ + "static/media/taste-the-story-logo.9780542e.svg";